<div class="chart-wrapper" [class.preview]="preview()">
    @if (title()) {
        <h5 class="chart-title-text">{{title()}}</h5>
    }
    <div [hidden]="!data()" class="chart" [style.height.px]="height()" [style.width.px]="width()">
        @if (!preview() && showTitle()) {
        <div class="chart-title-wrapper" [style.width.px]="width()" [style.height.px]="height()">
            <h4 class="chart-title-total">{{ total | currency: "USD":"symbol":"1.0-0"}}</h4>
        </div>
        }
        <canvas #ctx></canvas>
    </div>
    @if (!preview() && showLegend() && data()) {
        <chart-legend [selectedIndex]="hoveredIndex()" [items]="legendItems()" />
    }

    @if (!data()) {
    <div>
        <div class="empty-state">
            <app-ui-icon name="donut-chart" />
            <div>{{emptyTitle()}}</div>
        </div>
    </div>
    }
</div>
